const decodeBase64Url = (value = "") => {
  if (typeof value !== "string" || !value) {
    return null;
  }

  const normalizedValue = value.replace(/-/g, "+").replace(/_/g, "/");
  const remainder = normalizedValue.length % 4;
  const paddedValue =
    remainder === 0
      ? normalizedValue
      : `${normalizedValue}${"=".repeat(4 - remainder)}`;

  try {
    return globalThis.atob(paddedValue);
  } catch {
    return null;
  }
};

export const normalizeRole = (value) => {
  if (typeof value !== "string" || !value.trim()) {
    return null;
  }

  return value.trim().toUpperCase();
};

export const KNOWN_UI_ROLES = ["SUPER_ADMIN", "ADMIN", "RH", "COLLAB"];
export const ROLE_IMPLICATIONS = {
  SUPER_ADMIN: ["SUPER_ADMIN", "ADMIN", "RH"],
  ADMIN: ["ADMIN", "RH"],
  RH: ["RH"],
  COLLAB: ["COLLAB"],
};

export const decodeJwtPayload = (token) => {
  if (typeof token !== "string" || !token) {
    return null;
  }

  const parts = token.split(".");
  if (parts.length < 2) {
    return null;
  }

  const decodedPayload = decodeBase64Url(parts[1]);
  if (!decodedPayload) {
    return null;
  }

  try {
    return JSON.parse(decodedPayload);
  } catch {
    return null;
  }
};

export const getRoleFromToken = (token) => {
  const payload = decodeJwtPayload(token);

  if (Array.isArray(payload?.roles) && payload.roles.length > 0) {
    return normalizeRole(payload.roles[0]);
  }

  return normalizeRole(payload?.role);
};

export const getRoleFromUser = (user) => {
  if (Array.isArray(user?.roles) && user.roles.length > 0) {
    return normalizeRole(user.roles[0]);
  }

  return normalizeRole(user?.role);
};

export const resolveUserRole = (user, token) =>
  getRoleFromUser(user) || getRoleFromToken(token);

export const hasRequiredRole = (role, roles = []) => {
  const currentRole = normalizeRole(role);

  if (!currentRole || !Array.isArray(roles) || roles.length === 0) {
    return false;
  }

  const impliedRoles = ROLE_IMPLICATIONS[currentRole];
  if (!Array.isArray(impliedRoles)) {
    return false;
  }

  return roles
    .map(normalizeRole)
    .some((requiredRole) => impliedRoles.includes(requiredRole));
};

export const isAdminUiRole = (role) => hasRequiredRole(role, ["ADMIN", "RH"]);
export const isKnownUiRole = (role) => hasRequiredRole(role, KNOWN_UI_ROLES);

export const getHomePathForRole = (role) => {
  const normalizedRole = normalizeRole(role);

  if (normalizedRole === "ADMIN") {
    return "/admin/dashboard";
  }

  if (normalizedRole === "SUPER_ADMIN") {
    return "/admin/dashboard";
  }

  if (normalizedRole === "RH") {
    return "/recrutement/dashboard";
  }

  if (normalizedRole === "COLLAB") {
    return "/collab";
  }

  return null;
};

export const hasRecruitmentProfile = user => (user?.recruitment_profiles || []).some(profile => ['rh','cto','cco'].includes(String(profile).toLowerCase()));
